$(function () {
    var imgSrcs = [];
    var $progressBar = $('#js-loading-bar');
    var $num = $('#js-loading-num');
    var $inner = $('#js-loading-inner');
    var $loading = $('#js-loading');

    $('body, html').find('img').each(function(){
        imgSrcs.push($(this).attr('src'));
    });
    var loader = new $.ImgLoader({
        srcs : imgSrcs, //画像などのパスを配列に格納
        pipesize: 2, //同時にロードできる数の上限
        delay: 500,  //次のロードまでの遅延をミリ秒で指定
        timeout: 500,  //タイムアウトまでの時間をミリ秒で指定
        useXHR2: false //XMLHttpRequestVersion2を利用するかどうか
    });

    loader.on('progress', function(progress){
        //console.log(progress.loadedRatio);
        TweenMax.to($progressBar, 0.5, {
            width: progress.loadedRatio*100 + '%' //進捗率を取得
        });
        $num.text(parseInt(progress.loadedRatio*100));
    });

    loader.on('allload', function($img){
        //console.log('done');
        $('body').addClass('is-loaded');
        setTimeout(function(){
            $inner.addClass('is-loaded').on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend', function(){

            });
            $loading.addClass('is-loaded').on('oTransitionEnd mozTransitionEnd webkitTransitionEnd transitionend', function(){
                $loading.addClass('is-hide');
                $(window).trigger('imageloaded');
            });
        }, 1000);
    });

    loader.load();
});




/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/loading.js
 ** module id = 4
 ** module chunks = 0
 **/